import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'spinner-icon',
  templateUrl: './spinner-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SpinnerIconComponent {}
